import React from 'react';
import {Image,View,Text,type ImageSourcePropType} from 'react-native';
import {modelProduct,modelName} from '../shared/model-products.js';

const images:Record<string,ImageSourcePropType>={
 'qtracker-go':require('../../assets/models/qtracker-go.png'),
 'qtracker-go-plus':require('../../assets/models/qtracker-go-plus.png'),
 'qtracker-max':require('../../assets/models/qtracker-max.png'),
 'qtracker-max-pro':require('../../assets/models/qtracker-max-pro.png'),
 'qtracker-drive':require('../../assets/models/qtracker-drive.png'),
 'qtracker-drive-pro':require('../../assets/models/qtracker-drive-pro.png'),
 'qtracker-drive-obd':require('../../assets/models/qtracker-drive-obd.png'),
 'qtracker-care-go':require('../../assets/models/qtracker-care-go.png'),
 'qtracker-care-band':require('../../assets/models/qtracker-care-band.png'),
 'qtracker-care-watch':require('../../assets/models/qtracker-care-watch.png'),
 'qtracker-pet-go':require('../../assets/models/qtracker-pet-go.png'),
 'qtracker-pet-go-mini':require('../../assets/models/qtracker-pet-go-mini.png'),
};
export function ModelIcon({profile,size=32}:{profile?:{model?:string}|null;size?:number}){
 const product=modelProduct(profile),source=product?images[product.iconId??product.id]:null;
 if(!source)return <View accessibilityLabel={modelName(profile)||'Qtracker'} style={{width:size,height:size,alignItems:'center',justifyContent:'center'}}><Text style={{fontSize:size*.65,color:'#708090'}}>?</Text></View>;
 return <Image source={source} resizeMode="contain" accessibilityLabel={product!.name} style={{width:size,height:size,flexShrink:0}}/>;
}
